import { render } from "./Brand.vue?vue&type=template&id=4fbbe102&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=4fbbe102&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ShelfDat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbbe102"]])

export default __exports__